import { AuthService } from ".";


export function hasAccessToCalculatorModule() {
  if ((AuthService.isVendorTeamLead() && !AuthService.isESA()) ||
    (AuthService.isVendorUser() && !AuthService.isESA()) ||
    (AuthService.isVendorAdmin() && !AuthService.isESA())) {
    return false;
  }
  return true;
}

export default {
  hasAccessToCalculatorModule
};
